<div class="conatiner-search">
    <ra-input
        [id]="'input-search-feed'"
        [placeholder]="'order.feed.searchPlaceholder' | translate"
        [formControl]="searchControl"
        [showRequiredOrOptional]="false"
        [loading]="feedMainService.loading() && !!searchControl.value"
    />

    <!-- "+" primário compacto: abre o wizard "Criar com IA" (tipo → modelo → contexto),
         que também leva a ordem de serviço e ao import -->
    <ra-square-icon
        [id]="'square-icon-feed-new'"
        [icon]="'add'"
        [type]="'primary'"
        [iconSize]="20"
        [tooltip]="'order.feed.newTooltip' | translate"
        [tooltipPosition]="'bottom'"
        (click)="feedMainService.requestIaWizard()"
    />

    <!-- "···": abre a MODAL de utilidades (arquivados e lixeira) -->
    <ra-square-icon
        [id]="'square-icon-feed-more'"
        [icon]="'more'"
        [tooltip]="'order.feed.moreOptions' | translate"
        [tooltipPosition]="'bottom'"
        (click)="isMoreMenuVisible.set(true)"
    />
</div>

<!-- Modal de utilidades: mesmo padrão da modal de criação; Lixeira em danger -->
@if (isMoreMenuVisible()) {
    <ra-modal
        [title]="'order.feed.moreOptions' | translate"
        (close)="isMoreMenuVisible.set(false)">
        <div class="new-modal-options">
            <div class="new-modal-step">
                <ra-option-list [items]="moreOptions()" (select)="onMoreOptionSelect($event)" />
            </div>
        </div>
    </ra-modal>
}

@if (isImportDocumentsVisible()) {
    <!-- orderId null = documento AVULSO (o backend cria a order pessoal) -->
    <import-documents-modal
        [orderId]="null"
        (created)="onImportCreated()"
        (close)="isImportDocumentsVisible.set(false)"
    />
}

@if (isArchivedPanelVisible()) {
    <!-- Modo feed: arquivados mistos (grupos + avulsos) -->
    <order-archived-panel [feedMode]="true" (close)="isArchivedPanelVisible.set(false)" />
}

@if (isTrashPanelVisible()) {
    <order-trash-panel (close)="isTrashPanelVisible.set(false)" />
}

<div class="feed-body" [class.feed-body--dragging]="draggingId() !== null">
    <!-- Trilho dos grupos: Todos, um botão por grupo (iniciais + cor), sem grupo,
         e "+". Cada botão de grupo também é alvo de arraste. -->
    <nav class="feed-rail" [attr.aria-label]="'order.feed.groups.railLabel' | translate">
        <button
            type="button"
            class="feed-rail__item feed-rail__item--all"
            [class.on]="feedMainService.groupId() === null"
            [attr.aria-pressed]="feedMainService.groupId() === null"
            data-group="all"
            [raTooltip]="{ text: ('order.feed.groups.all' | translate), position: 'right' }"
            (click)="selectGroup(null)">
            <ra-icon icon="list-bullet" [size]="18" [varColor]="feedMainService.groupId() === null ? 'contentInverse' : 'contentSecondary'" />
        </button>

        <span class="feed-rail__sep" aria-hidden="true"></span>

        @for (group of feedGroupService.groups(); track group._id) {
            <button
                type="button"
                class="feed-rail__item"
                [class.on]="feedMainService.groupId() === group._id"
                [class.over]="dropTarget() === group._id"
                [class.pop]="poppedTargetId() === group._id"
                [attr.aria-pressed]="feedMainService.groupId() === group._id"
                [attr.data-group]="group._id"
                [style.--group-color]="group.color || 'var(--contentTertiary)'"
                [raTooltip]="{ text: group.name + ' · ' + (group.orderIds?.length ?? 0), position: 'right' }"
                (click)="selectGroup(group._id)"
                (dragover)="onDragOver($event, group._id)"
                (dragleave)="onDragLeave(group._id)"
                (drop)="onDrop($event, group._id)">
                {{ initials(group.name) }}
            </button>
        }

        <button
            type="button"
            class="feed-rail__item feed-rail__item--none"
            [class.on]="feedMainService.groupId() === groupNone"
            [class.over]="dropTarget() === groupNone"
            [class.pop]="poppedTargetId() === groupNone"
            [attr.aria-pressed]="feedMainService.groupId() === groupNone"
            [attr.data-group]="groupNone"
            [raTooltip]="{ text: ('order.feed.groups.none' | translate), position: 'right' }"
            (click)="selectGroup(groupNone)"
            (dragover)="onDragOver($event, groupNone)"
            (dragleave)="onDragLeave(groupNone)"
            (drop)="onDrop($event, groupNone)">
            <ra-icon icon="folder-open" [size]="16" [varColor]="feedMainService.groupId() === groupNone ? 'contentInverse' : 'contentSecondary'" />
        </button>

        <button
            type="button"
            class="feed-rail__item feed-rail__item--add"
            [attr.aria-label]="'order.feed.groups.new' | translate"
            [raTooltip]="{ text: ('order.feed.groups.new' | translate), position: 'right' }"
            (click)="openGroupModal()">
            <ra-icon icon="add" varColor="contentSecondary" [size]="18" />
        </button>
    </nav>

    <div class="feed-main">
        <!-- Aviso do alvo durante o arraste: o chip pode cobrir o botão do trilho,
             então o nome do destino aparece aqui, fora do caminho do cursor. -->
        @if (dropTargetName(); as targetName) {
            <div class="feed-drop-hint" role="status">
                <span class="feed-drop-hint__dot" [style.background-color]="dropTargetColor() || 'var(--contentTertiary)'"></span>
                {{ 'order.feed.groups.dropIn' | translate: { name: targetName } }}
            </div>
        }

        @if (feedMainService.loading() && !feedMainService.items().length) {
            <div class="container-feed-list">
                <!-- Uma linha por item da primeira página; a altura espelha a do feed-row -->
                <ra-skeleton [count]="skeletons.length" [height]="62" [radius]="12" [gap]="4" />
            </div>
        }
        @else if (!feedMainService.items().length) {
            @if (feedMainService.groupId() && feedMainService.groupId() !== groupNone) {
                <!-- Grupo vazio: diz como encher -->
                <ra-empty
                    animate.enter="empty-enter"
                    [title]="'order.feed.groups.emptyTitle' | translate"
                    [message]="'order.feed.groups.emptyMessage' | translate"
                />
            }
            @else {
                <ra-empty
                    animate.enter="empty-enter"
                    [title]="'order.feed.emptyTitle' | translate"
                    [message]="'order.feed.emptyMessage' | translate"
                />
            }
        }
        @else {
            <div class="container-feed-list">
                @for (section of sections(); track section.id) {
                    <section
                        class="feed-group"
                        [class.feed-group--collapsed]="section.collapsed"
                        [class.feed-group--flat]="feedMainService.groupId() !== null"
                        [class.over]="dropTarget() === section.id"
                        (dragover)="onDragOver($event, section.id)"
                        (dragleave)="onDragLeave(section.id)"
                        (drop)="onDrop($event, section.id)">

                        <!-- Cabeçalho da seção: chevron (só em Todos), cor, nome, contagem
                             e as opções do grupo. O "sem grupo" não tem opções. -->
                        <header
                            class="feed-group__head"
                            [class.feed-group__head--toggle]="feedMainService.groupId() === null"
                            [class.pop]="poppedTargetId() === section.id"
                            (click)="onSectionHeadClick($event, section)">
                            @if (feedMainService.groupId() === null) {
                                <!-- Sem (click) próprio: o clique sobe até o cabeçalho, que é
                                     quem abre/fecha. Com os dois, a seta alternava duas vezes
                                     e parecia não fazer nada. -->
                                <button
                                    type="button"
                                    class="feed-group__toggle"
                                    [attr.aria-expanded]="!section.collapsed"
                                    [attr.aria-label]="(section.collapsed ? 'order.feed.groups.expand' : 'order.feed.groups.collapse') | translate">
                                    <ra-icon icon="arrow-down" varColor="contentTertiary" [size]="14" />
                                </button>
                            }
                            @if (section.color) {
                                <span class="feed-group__dot" [style.background-color]="section.color" aria-hidden="true"></span>
                            }
                            @if (renamingId() === section.id) {
                                <!-- Renomear inline: Enter/blur salva, Esc cancela -->
                                <input
                                    #renameInput
                                    type="text"
                                    class="feed-group__rename"
                                    [value]="section.name"
                                    maxlength="60"
                                    [attr.aria-label]="'order.feed.groups.name' | translate"
                                    (keydown.enter)="commitRename(section, renameInput.value)"
                                    (keydown.escape)="cancelRename()"
                                    (blur)="commitRename(section, renameInput.value)"
                                />
                            }
                            @else {
                                <span
                                    class="feed-group__name"
                                    [class.feed-group__name--editable]="!!section.group"
                                    [raTooltip]="section.group ? { text: ('order.feed.groups.renameHint' | translate), position: 'top' } : null"
                                    (click)="startRename(section)">{{ section.name }}</span>
                            }
                            <span class="feed-group__spacer"></span>
                            <span class="feed-group__count">{{ section.group ? (section.group.orderIds?.length ?? 0) : section.items.length }}</span>
                            @if (section.group) {
                                <button
                                    type="button"
                                    class="feed-group__more"
                                    [attr.aria-label]="'order.feed.groups.options' | translate"
                                    [raTooltip]="{ text: ('order.feed.groups.options' | translate), position: 'left' }"
                                    (click)="openGroupModal(section.group)">
                                    <ra-icon icon="more" varColor="contentTertiary" [size]="16" />
                                </button>
                            }
                        </header>

                        <!-- Corpo sempre no DOM: abrir/fechar é transição de altura
                             (grid-template-rows), não um @if que some de uma vez. -->
                        <div
                            class="feed-group__body"
                            [class.feed-group__body--collapsed]="section.collapsed"
                            [attr.aria-hidden]="section.collapsed"
                            [attr.inert]="section.collapsed ? '' : null">
                        <div class="feed-group__inner">
                            @if (!section.items.length) {
                                <!-- Grupo sem item carregado: alvo de arraste visível -->
                                <p class="feed-group__drop-hint">{{ 'order.feed.groups.dropHint' | translate }}</p>
                            }
                            @for (item of section.items; track item._id; let i = $index) {
                    <!-- A linha é um WRAPPER, não um botão: as ações (arquivar/cancelar)
                         são botões de verdade e `<button>` dentro de `<button>` é HTML
                         inválido — o navegador desfaz o aninhamento e a ação deixa de
                         receber foco. Abrir o item é o `feed-row__main`; as ações são
                         irmãs dele. -->
                    <div
                        class="feed-row"
                        animate.enter="card-enter"
                        draggable="true"
                        [attr.data-id]="item._id"
                        [style.--enter-delay]="(i % 10) * 40 + 'ms'"
                        [class.dragging]="draggingId() === item._id"
                        [class.pressing]="pressingId() === item._id"
                        [class.landed]="landedId() === item._id"
                        (pointerdown)="onPressStart(item, $event)"
                        (pointerup)="onPressEnd()"
                        (pointercancel)="onPressEnd()"
                        (pointerleave)="onPressEnd()"
                        (dragstart)="onDragStart($event, item)"
                        (dragend)="onDragEnd()"
                        [class.active]="item.type === feedItemTypeEnum.GROUP && orderMainService.currentOrder()?._id === item._id"
                        [class.loading]="openingItemId() === item._id"
                        [class.generating]="isGenerating(item) || isBatchRunning(item)">

                        <!-- Sem `disabled` de propósito: em geração o clique ainda precisa
                             chegar ao TS, que avisa por toast o motivo da espera. -->
                        <button
                            type="button"
                            class="feed-row__main"
                            (click)="openItem(item)">

                        @if (item.type === feedItemTypeEnum.GROUP) {
                            <!-- Grupo: pasta como identidade + avatares dos responsáveis no canto -->
                            <span class="feed-row__avatar feed-row__avatar--group">
                                <ra-icon icon="folder" varColor="backgroundPrimary" [size]="22" />
                                @if (item.employees?.length) {
                                    <span class="feed-row__team">
                                        <ra-avatars-list
                                            [users]="item.employees"
                                            [avatarSize]="14"
                                            [maxVisible]="2"
                                        />
                                    </span>
                                }
                            </span>
                        }
                        @else {
                            <!-- Documento: a identidade é o TIPO (mesma convenção dos cards
                                 de criação e do card dentro do serviço) — azul/normal,
                                 verde/contrato, laranja/orçamento. -->
                            <span
                                class="feed-row__avatar feed-row__avatar--document"
                                [style.background-color]="'var(--' + (item.document?.type | iconColorByDocumentType) + ')'">
                                <ra-icon [icon]="item.document?.type | iconByDocumentType" varColor="contentInverse" [size]="20" />
                                <!-- Responsáveis do documento no canto (espelha a equipe do serviço) -->
                                @if (item.document?.responsibles?.length) {
                                    <span class="feed-row__team">
                                        <ra-avatars-list
                                            [users]="responsibleUsers(item)"
                                            [avatarSize]="14"
                                            [maxVisible]="2"
                                        />
                                    </span>
                                }
                            </span>
                        }

                        <span class="feed-row__content">
                            <span class="feed-row__top">
                                <strong class="feed-row__title">{{ itemTitle(item) }}</strong>
                            </span>
                            <span class="feed-row__subtitle">
                                @if (item.type === feedItemTypeEnum.GROUP) {
                                    <!-- Título é sempre o cliente; subtítulo é o código da
                                         ordem de serviço (quando existe) + a contagem -->
                                    @if (item.code) {
                                        <ra-badge
                                            [label]="'order.common.codeLabel' | translate: { code: item.code }"
                                            [variant]="'primary'"
                                            [size]="'small'"
                                        />
                                    }
                                    @if (isBatchRunning(item)) {
                                        <!-- Pacote de PDFs em andamento: mesmo loading do documento
                                             em geração, para o serviço não parecer parado enquanto
                                             a pessoa navega por outras telas. -->
                                        <span class="feed-row__spinner" aria-hidden="true"></span>
                                        <span class="feed-row__generating-label">
                                            {{ (batchService.zipping()
                                                ? 'order.documentBatch.zippingTitle'
                                                : 'order.documentBatch.feedGenerating') | translate }}
                                        </span>
                                    } @else {
                                        {{ 'order.feed.documentsCount' | translate: { count: item.documentsCount } }}
                                    }
                                }
                                @else if (isGenerating(item)) {
                                    <!-- Worker de IA ainda montando o documento: loading + aviso; o clique é bloqueado -->
                                    <span class="feed-row__spinner" aria-hidden="true"></span>
                                    <span class="feed-row__generating-label">{{ generationStageLabel(item) }}</span>
                                }
                                @else if (hasGenerationError(item)) {
                                    <ra-badge [label]="'order.feed.generationError' | translate" [variant]="'danger'" [size]="'small'" />
                                }
                                @else {
                                    <!-- Subtítulo do avulso = o tamanho (o análogo da contagem de
                                         documentos do grupo). SEM selo "Doc avulso": o tipo já é a
                                         identidade da linha — ícone + cor do avatar. A chave
                                         `standaloneBadge` segue viva no painel de arquivados, onde
                                         não há ícone e o texto é o único distintivo. -->
                                    <span class="feed-row__size">{{ item.document?.sizeGB | formatFileSize:'GB' }}</span>

                                    @if (item.document?.generatedByIa) {
                                        <!-- Mesmo badge do card do documento no detalhe, na variante densa -->
                                        <ra-badge
                                            [label]="'order.feed.iaBadge' | translate"
                                            [variant]="'primary'"
                                            [icon]="'magicpen'"
                                            [size]="'small'"
                                        />
                                    }
                                }
                            </span>

                            @if (isBatchRunning(item) && !batchService.zipping()) {
                                <ra-progress-bar
                                    class="feed-row__progress-row"
                                    [value]="batchService.percent()"
                                    [showValue]="true"
                                    [ariaLabel]="batchProgressLabel()"
                                />
                            }

                            @let generationProgress = isGenerating(item) ? generationPercent(item) : null;
                            @if (generationProgress !== null) {
                                <!--
                                    Barra em LINHA PRÓPRIA, abaixo do rótulo: na mesma linha ela
                                    ficava espremida entre textos e mal dava pra ver a evolução.
                                    O % vai na ponta direita, alinhado com a barra.
                                    Progresso PERSISTIDO no backend: sobrevive a recarregar a tela e
                                    é o mesmo em qualquer aparelho.
                                -->
                                <ra-progress-bar
                                    class="feed-row__progress-row"
                                    [value]="generationProgress"
                                    [showValue]="true"
                                    [ariaLabel]="generationStageLabel(item)"
                                />
                            }
                        </span>
                        </button>

                        <!-- "···" da linha: mover para grupo / ordem de serviço, arquivar,
                             excluir. Em geração só dá para cancelar (abaixo). -->
                        @if (!isGenerating(item)) {
                            <div
                                class="feed-row__menu"
                                [class.feed-row__menu--open]="rowMenu()?.itemId === item._id"
                                clickOutside
                                (clickOutside)="closeRowMenu(item)">
                                <button
                                    type="button"
                                    class="feed-row__action"
                                    [class.feed-row__action--open]="rowMenu()?.itemId === item._id"
                                    [attr.aria-label]="'order.feed.rowMenu.options' | translate"
                                    [attr.aria-expanded]="rowMenu()?.itemId === item._id"
                                    (click)="toggleRowMenu(item)">
                                    <ra-icon icon="more" varColor="contentSecondary" [size]="16" />
                                </button>
                                @if (rowMenu()?.itemId === item._id) {
                                    <ra-menu
                                        [items]="rowMenuItems(item)"
                                        [width]="240"
                                        (select)="onRowMenuSelect(item, $event)"
                                    />
                                }
                            </div>
                        }
                        <!-- Cancelar import em andamento: remove o placeholder e para a geração.
                             Só faz sentido enquanto está gerando (import travado ou desistência) -->
                        @if (item.type === feedItemTypeEnum.DOCUMENT && isGenerating(item)) {
                            <button
                                type="button"
                                class="feed-row__action feed-row__action--cancel"
                                [attr.aria-label]="'order.feed.cancelImportTooltip' | translate"
                                [raTooltip]="{ text: ('order.feed.cancelImportTooltip' | translate), position: 'left' }"
                                (click)="cancelImport(item)">
                                <ra-icon icon="close" varColor="contentSecondary" [size]="16" />
                            </button>
                        }
                    </div>
                            }
                        </div>
                        </div>
                    </section>
                }
            </div>

            @if (feedMainService.loading()) {
                <div class="container-load-more">
                    <ra-loading [size]="'small'" />
                </div>
            }
            @else if (feedMainService.paginate()?.page < feedMainService.paginate()?.totalPages) {
                <div class="container-load-more">
                    <ra-button
                        [label]="'order.common.loadMore' | translate"
                        [type]="'primary'"
                        (click)="getFeed(feedMainService.paginate()?.page + 1)" />
                </div>
            }
        }
    </div>
</div>

<!-- Modal de grupo: nome + cor; ao editar, também "Desfazer grupo" -->
@if (groupModal(); as modal) {
    <ra-modal
        [title]="groupModalTitle() | translate"
        [size]="'small'"
        (close)="closeGroupModal()">
        <form class="group-modal" (ngSubmit)="saveGroup()">
            <ra-input
                [id]="'input-feed-group-name'"
                [label]="'order.feed.groups.name' | translate"
                [placeholder]="'order.feed.groups.namePlaceholder' | translate"
                [formControl]="groupNameControl"
                [showRequiredOrOptional]="false"
                [errorMessage]="'order.feed.groups.nameRequired' | translate"
            />

            <div class="group-modal__colors" role="radiogroup" [attr.aria-label]="'order.feed.groups.color' | translate">
                <span class="group-modal__label">{{ 'order.feed.groups.color' | translate }}</span>
                <div class="group-modal__swatches">
                    @for (color of groupColors; track color) {
                        <button
                            type="button"
                            class="group-modal__swatch"
                            role="radio"
                            [class.on]="groupColor() === color"
                            [attr.aria-checked]="groupColor() === color"
                            [style.--swatch]="color"
                            (click)="groupColor.set(color)">
                            @if (groupColor() === color) {
                                <ra-icon icon="tick" varColor="contentInverse" [size]="12" />
                            }
                        </button>
                    }
                    <button
                        type="button"
                        class="group-modal__swatch group-modal__swatch--none"
                        role="radio"
                        [class.on]="groupColor() === null"
                        [attr.aria-checked]="groupColor() === null"
                        [raTooltip]="{ text: ('order.feed.groups.noColor' | translate), position: 'top' }"
                        (click)="groupColor.set(null)">
                    </button>
                </div>
            </div>

            <div class="group-modal__actions">
                @if (modal.group) {
                    <ra-button
                        [id]="'button-feed-group-remove'"
                        [label]="'order.feed.groups.remove' | translate"
                        [type]="'danger-outline'"
                        [disabled]="savingGroup()"
                        (click)="removeGroup(modal.group)"
                    />
                }
                <span class="group-modal__spacer"></span>
                <ra-button
                    [id]="'button-feed-group-save'"
                    [label]="(modal.group ? 'order.feed.groups.save' : 'order.feed.groups.create') | translate"
                    [type]="'primary'"
                    [loading]="savingGroup()"
                    [disabled]="groupNameControl.invalid"
                    (click)="saveGroup()"
                />
            </div>
        </form>
    </ra-modal>
}

@if (isModalCreateOrderVisible()) {
    <order-create
        (close)="isModalCreateOrderVisible.set(false)"
        (created)="orderCreated($event)"
    />
}

<!-- Criando o documento avulso: mesma tela de loading do detalhe do serviço -->
<!-- Imagem do arraste (ver `_setDragChip`): fica fora da tela e é preenchida no dragstart -->
<div class="feed-drag-chip" aria-hidden="true">
    <span class="feed-drag-chip__avatar"></span>
    <span class="feed-drag-chip__text">
        <strong class="feed-drag-chip__title"></strong>
        <small class="feed-drag-chip__subtitle"></small>
    </span>
</div>

<!-- Avulso → ordem de serviço: o mesmo seletor do detalhe do serviço -->
@if (documentToMove(); as item) {
    <ra-modal-list-orders
        [message]="'order.details.documentMenu.moveMessage' | translate: { title: itemTitle(item) }"
        (close)="documentToMove.set(null)"
        (selectOrder)="moveDocumentToOrder($event)"
    />
}
